export default __webpack_public_path__ + "static/media/xwin-Team-PhotosYuki.551a2014.png";